// Grab the history from the session storage
const sessionJourney = sessionStorage.getItem('userjourney');
// Grab an js-back elements
const back = [...document.querySelectorAll('.js-back')];

// Create a new array to store the user's history
window.userjourney = [];

// If the session history exists, parse it and set it to the window.history array
if (sessionJourney) {
  window.userjourney = JSON.parse(sessionJourney);
}

// get the current pathname without the trailing slash
const currentPath = window.location.pathname.replace(/\/$/, '');

// If the current page href is not the same as the last item in the userjourney, add the current page to the userjourney
if (window.userjourney[window.userjourney.length - 1] !== currentPath) {
  const path = window.location.pathname.replace(/\/$/, '');
  window.userjourney.push(path);
}

// Limit the userjourney to the last 2 items
if (window.userjourney.length > 2) {
  window.userjourney.shift();
}

// Save the userjourney to the session storage
sessionStorage.setItem('userjourney', JSON.stringify(window.userjourney));

// If there are any back elements, add a click event to them
if (back.length) {
  // If the userjourney has a length of 2, go back to the first item in the array
  if (window.userjourney.length === 2) {
    back.forEach(el => {
      // if the element is a anchor tag, reset the href to the first item in the userjourney
      if (el.tagName === 'A') {
        return el.href = window.userjourney[0];
      }

      // Otherwise, add a click event to the element
      el.addEventListener('click', e => {
        e.preventDefault();
        window.location.href = window.userjourney[0];
      });
    });
  }
}